var _path, _rect, _rect2, _rect3, _g, _g2, _rect4, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1213_4152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1213_4152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 27.9741C4 19.1402 4 14.7233 5.74643 11.3613C7.21812 8.52816 9.52816 6.21812 12.3613 4.74643C15.7233 3 20.1402 3 28.9741 3H43.0259C51.8598 3 56.2767 3 59.6387 4.74643C62.4718 6.21812 64.7819 8.52816 66.2536 11.3613C68 14.7233 68 19.1402 68 27.9741V42.0259C68 50.8598 68 55.2767 66.2536 58.6387C64.7819 61.4718 62.4718 63.7819 59.6387 65.2536C56.2767 67 51.8598 67 43.0259 67H28.9741C20.1402 67 15.7233 67 12.3613 65.2536C9.52816 63.7819 7.21812 61.4718 5.74643 58.6387C4 55.2767 4 50.8598 4 42.0259V27.9741Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1213_4152)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(4 3)",
    fill: "#F18D8D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 64,
    height: 64,
    fill: "url(#paint0_linear_1213_4152)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1213_4152",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 64,
    height: 64
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 64,
    height: 64,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1213_4152)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1346 59.7847C50.8381 58.4556 53.2936 56.6988 55.412 54.6007L63.413 62.6017H48.1346V59.7847ZM36.1346 62.6017V62.5985C40.3309 62.5783 44.309 61.6183 47.868 59.9159V62.6017H36.1346ZM24.1346 62.6017V59.9159C27.6936 61.6183 31.6717 62.5783 35.868 62.5985V62.6017H24.1346ZM8.5901 62.6017L16.5906 54.6007C18.709 56.6988 21.165 58.4556 23.868 59.7847V62.6017H8.5901ZM11.2184 47.1351C12.5474 49.8385 14.3042 52.294 16.4024 54.4124L8.4013 62.4135V47.1351H11.2184ZM8.4013 35.1351H8.4045C8.42477 39.3319 9.38477 43.3095 11.0872 46.8684H8.4013V35.1351ZM8.4013 23.1351H11.0872C9.38477 26.694 8.42477 30.6721 8.4045 34.8684H8.4013V23.1351ZM8.4013 7.59054L16.4024 15.5911C14.3042 17.7095 12.5474 20.1655 11.2184 22.8684H8.4013V7.59054ZM23.868 10.2188C21.165 11.5479 18.709 13.3047 16.5906 15.4028L8.5901 7.40174H23.868V10.2188ZM35.868 7.40174V7.40494C31.6717 7.42521 27.6936 8.38574 24.1346 10.0876V7.40174H35.868ZM47.868 7.40174V10.0876C44.309 8.38574 40.3309 7.42521 36.1346 7.40494V7.40174H47.868ZM63.413 7.40174L55.412 15.4028C53.2936 13.3047 50.8381 11.5479 48.1346 10.2188V7.40174H63.413ZM60.7842 22.8684C59.4557 20.1655 57.6989 17.7095 55.6008 15.5911L63.6013 7.59054V22.8684H60.7842ZM63.6013 34.8684H63.5981C63.5784 30.6721 62.6178 26.694 60.916 23.1351H63.6013V34.8684ZM63.6013 46.8684H60.916C62.6178 43.3095 63.5784 39.3319 63.5981 35.1351H63.6013V46.8684ZM48.3234 47.1351H60.4845C59.1762 49.7655 57.4589 52.1569 55.412 54.2236L48.3234 47.1351ZM48.1346 47.3233L55.2237 54.4124C53.1565 56.4593 50.765 58.1761 48.1346 59.4849V47.3233ZM36.1346 52.1985C40.6802 52.1633 44.8088 50.3559 47.868 47.4348V59.622C44.3149 61.3415 40.3352 62.3116 36.1346 62.3319V52.1985ZM24.1346 47.4348C27.1938 50.3559 31.3224 52.1633 35.868 52.1985V62.3319C31.6674 62.3116 27.6877 61.3415 24.1346 59.622V47.4348ZM23.868 47.3239V59.4849C21.2381 58.1761 18.8461 56.4593 16.7794 54.4124L23.868 47.3239ZM23.6797 47.1351L16.5906 54.2236C14.5437 52.1569 12.8269 49.7655 11.5181 47.1351H23.6797ZM18.8045 35.1351C18.8397 39.6807 20.6472 43.8092 23.5682 46.8684H11.381C9.66157 43.3153 8.69143 39.3356 8.67117 35.1351H18.8045ZM23.5682 23.1351C20.6472 26.1943 18.8397 30.3228 18.8045 34.8684H8.67117C8.69143 30.6679 9.66157 26.6881 11.3816 23.1351H23.5682ZM23.6797 22.8684H11.5181C12.8269 20.2385 14.5437 17.8465 16.5906 15.7799L23.6797 22.8684ZM23.868 22.6796L16.7794 15.5911C18.8461 13.5441 21.2381 11.8273 23.868 10.5185V22.6796ZM35.868 17.8049C31.3224 17.8401 27.1938 19.6476 24.1346 22.5687V10.382C27.6877 8.66201 31.6674 7.69188 35.868 7.67161V17.8049ZM47.868 22.5687C44.8088 19.6476 40.6802 17.8401 36.1346 17.8049V7.67161C40.3352 7.69188 44.3149 8.66201 47.868 10.382V22.5687ZM48.1346 22.6801V10.5185C50.765 11.8273 53.1565 13.5441 55.2237 15.5911L48.1346 22.6801ZM48.3234 22.8684L55.412 15.7799C57.4589 17.8465 59.1757 20.2385 60.4845 22.8684H48.3234ZM53.1981 34.8684C53.1634 30.3228 51.3554 26.1943 48.4344 23.1351H60.6216C62.341 26.6881 63.3112 30.6679 63.3314 34.8684H53.1981ZM53.1981 35.1351H63.3314C63.3112 39.3356 62.341 43.3153 60.6216 46.8684H48.4344C51.3554 43.8092 53.1634 39.6807 53.1981 35.1351ZM36.1346 47.1351H47.796C44.7741 50.0737 40.6642 51.8967 36.1346 51.9319V47.1351ZM35.868 47.1351V51.9319C31.3384 51.8967 27.2285 50.0737 24.2066 47.1351H35.868ZM23.868 35.1351V46.7964C20.9298 43.7745 19.1069 39.6647 19.0712 35.1351H23.868ZM23.868 34.8684H19.0712C19.1069 30.3388 20.9298 26.2289 23.868 23.2071V34.8684ZM35.868 22.8684H24.2066C27.2285 19.9303 31.3384 18.1073 35.868 18.0716V22.8684ZM36.1346 22.8684V18.0716C40.6642 18.1073 44.7741 19.9303 47.796 22.8684H36.1346ZM48.1346 34.8684V23.2071C51.0733 26.2289 52.8962 30.3388 52.9314 34.8684H48.1346ZM48.1346 35.1351H52.9314C52.8962 39.6647 51.0733 43.7745 48.1346 46.7969V35.1351ZM36.1346 35.3233L47.6797 46.8684H36.1346V35.3233ZM35.868 35.3239V46.8684H24.3234L35.868 35.3239ZM35.6797 35.1351L24.1346 46.6801V35.1351H35.6797ZM35.6797 34.8684H24.1346V23.3233L35.6797 34.8684ZM35.868 34.6796L24.3234 23.1351H35.868V34.6796ZM36.1346 34.6801V23.1351H47.6797L36.1346 34.6801ZM47.868 35.1351V46.6796L36.3234 35.1351H47.868ZM36.3234 34.8684L47.868 23.3239V34.8684H36.3234ZM63.6013 62.4135L55.6008 54.4124C57.6989 52.294 59.4557 49.8385 60.7842 47.1351H63.6013V62.4135ZM68.7234 67.5351L64.0568 62.8684H68.1346V62.6017H63.868V47.1351H68.1346V46.8684H63.868V35.1351H68.1346V34.8684H63.868V23.1351H68.1346V22.8684H63.868V7.40174H68.1346V7.13508H64.0568L68.1901 3.00174L68.0013 2.81348L63.868 6.94681V2.86841H63.6013V7.13508H48.1346V2.86841H47.868V7.13508H36.1346V2.86841H35.868V7.13508H24.1346V2.86841H23.868V7.13508H8.4013V2.86841H8.13463V6.94681L4.0013 2.81348L3.8125 3.00174L7.94637 7.13508H3.86797V7.40174H8.13463V22.8684H3.86797V23.1351H8.13463V34.8684H3.86797V35.1351H8.13463V46.8684H3.86797V47.1351H8.13463V62.6017H3.86797V62.8684H7.94637L3.8125 67.0017L4.0013 67.1905L8.13463 63.0572V67.1351H8.4013V62.8684H23.868V67.1351H24.1346V62.8684H35.868V67.1351H36.1346V62.8684H47.868V67.1351H48.1346V62.8684H63.6013V67.1351H63.868V63.0572L68.5346 67.7239L68.7234 67.5351Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.720266,
    x: 14.8125,
    y: 5.8125,
    width: 42.5,
    height: 58.5,
    rx: 4.4375,
    stroke: "white",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.720266,
    x: 10.8125,
    y: 9.8125,
    width: 50.5,
    height: 50.5,
    rx: 4.4375,
    stroke: "white",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.720266,
    x: 6.8125,
    y: 13.8125,
    width: 58.5,
    height: 42.5,
    rx: 4.4375,
    stroke: "white",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 5.8125C52.2168 5.8125 65.3125 18.9082 65.3125 35.0625C65.3125 51.2168 52.2168 64.3125 36.0625 64.3125C19.9082 64.3125 6.8125 51.2168 6.8125 35.0625C6.8125 18.9082 19.9082 5.8125 36.0625 5.8125Z",
    stroke: "white",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 21.9375C43.3112 21.9375 49.1875 27.8138 49.1875 35.0625C49.1875 42.3112 43.3112 48.1875 36.0625 48.1875C28.8138 48.1875 22.9375 42.3112 22.9375 35.0625C22.9375 27.8138 28.8138 21.9375 36.0625 21.9375Z",
    stroke: "white",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8125,
    y: 25.8125,
    width: 18.5,
    height: 18.5,
    stroke: "white",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 3.0625V67.0625",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 3V67",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 3V67",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0625 25.8125H4.0625",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 35.0625H4",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0625 44.3125H4.0625",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 3.0625L68.0625 67.0625",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0625 3.0625L4.0625 67.0625",
    stroke: "white",
    strokeWidth: 0.125,
    strokeLinecap: "square"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 67.3125,
    height: 67.3125,
    transform: "translate(2.3125 1.375)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6093 14.9064C27.2724 18.0418 25.2765 23.9163 24.8499 30.4994C24.7061 33.5039 25.0302 36.5126 25.8105 39.4162C22.2035 33.9142 19.7422 26.9406 20.5567 21.1803C20.6264 20.8109 20.5771 20.4288 20.4161 20.0896C20.2552 19.7504 19.9908 19.4717 19.6616 19.2942C17.9999 18.3542 16.0666 20.0691 16.6782 21.871C18.9874 28.7515 22.0245 35.9534 26.5236 41.8008C28.7224 48.363 32.7888 54.4896 37.3864 58.9375C33.6986 54.7549 30.8325 49.9059 28.9402 44.6479C31.719 47.6692 35.0909 50.0767 38.8423 51.7176C50.8746 56.8953 59.4043 43.6568 47.5987 36.4009C44.8152 34.8122 39.43 33.6979 36.5241 35.7732C34.9817 36.8874 35.283 39.3441 37.088 39.9147C37.1986 39.9482 37.3112 39.9743 37.4251 39.9928C37.8281 40.0422 38.2364 39.969 38.5976 39.7826C44.4422 37.0406 54.5293 43.0862 48.7175 49.366C43.0489 53.5706 35.3397 49.5102 30.769 45.3417C29.9046 44.5509 29.0924 43.7041 28.3375 42.8069C26.8935 38.0016 26.4281 32.9501 27.4783 28.2019C28.7194 23.4177 30.0888 19.6636 34.561 16.9517C46.0264 12.0473 52.2529 29.5654 39.9491 33.8992C52.3215 30.4124 48.2372 14.0625 37.8339 14.0625C36.3859 14.0779 34.9534 14.3641 33.6093 14.9064Z",
    fill: "url(#paint1_linear_1213_4152)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1213_4152",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1213_4152"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1213_4152",
    result: "effect2_dropShadow_1213_4152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1213_4152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1213_4152",
    x1: 36,
    y1: 3,
    x2: 36,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED3DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1213_4152",
    x1: 34.9062,
    y1: 14.0625,
    x2: 34.9062,
    y2: 58.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45276E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.e8e0169dbb77a72cf74385a5f4c741e8.svg";
export { ForwardRef as ReactComponent };